module.exports = __webpack_public_path__ + "img/tech18_edit.cf3c7651.png";